import { baseurl } from "../../api";
import authenticatedAxios from "../../authenticatedAxios";

// ─── STATS ────────────────────────────────────────────────────────────────────

export const fetchFeedbackStats = async () => {
  try {
    const response = await authenticatedAxios.get(`${baseurl}feedback/stats/`);
    // Backend returns { success, message, data: {...} }
    // Return just the inner data so component can use res.data directly
    return { data: response.data?.data || null };
  } catch (error) {
    console.error("fetchFeedbackStats error:", error);
    return { data: null };
  }
};


export const fetchFeedbackIssues = async () => {
  try {
    const response = await authenticatedAxios.get(`${baseurl}feedback/issues/`);
    // Backend returns: { success, message, data: [...] }
    return response.data?.data || [];
  } catch (error) {
    console.error("fetchFeedbackIssues error:", error);
    return [];
  }
};

// ─── LIST ─────────────────────────────────────────────────────────────────────

export const fetchFeedbacks = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    if (filters.rating)     params.set("rating",     filters.rating);
    if (filters.issue_id)   params.set("issue_id",   filters.issue_id);
    if (filters.date_range) params.set("date_range",  filters.date_range);
    if (filters.search)     params.set("search",      filters.search);
    if (filters.page)       params.set("page",        filters.page);
    if (filters.page_size)  params.set("page_size",   filters.page_size);

    const response = await authenticatedAxios.get(
      `${baseurl}feedback/list/?${params.toString()}`
    );

    const result = response.data;
    // Backend returns: { success, message, data: [...], pagination: { total_count, ... } }
    return {
      results: result?.data || [],
      count:   result?.pagination?.total_count || result?.data?.length || 0,
    };

  } catch (error) {
    console.error("fetchFeedbacks error:", error);
    return { count: 0, results: [] };
  }
};

// ─── STATUS UPDATE ────────────────────────────────────────────────────────────

export const updateFeedbackStatus = async (id, newStatus) => {
  try {
    const response = await authenticatedAxios.patch(
      `${baseurl}feedback/${id}/status/`,
      { status: newStatus }
    );
    return response.data;
  } catch (error) {
    console.error("updateFeedbackStatus error:", error);
    return null;
  }
};